import type { Connection, Connections } from '@common/types/Area'
import { mapOrd, rawOrd } from '@lc/libarray'
import {
	createEntityAdapter,
	createSlice,
	type WithSlice,
} from '@reduxjs/toolkit'
import { reducer } from './store'

export const connectionsAdapter = createEntityAdapter({
	selectId: (connections: Connections) => connections.area,
	sortComparer: mapOrd(rawOrd, connections => connections.area),
})

declare module './store' {
	// eslint-disable-next-line @typescript-eslint/no-empty-object-type
	export interface LoadedSlices extends WithSlice<typeof connectionsSlice> {}
}
const { selectById } = connectionsAdapter.getSelectors()

export type ConnectionsSlice = ReturnType<
	(typeof connectionsSlice)['getInitialState']
>
export const connectionsSlice = createSlice({
	name: 'connections',
	initialState: connectionsAdapter.getInitialState(),
	reducers: {
		setConnections: connectionsAdapter.setOne,
		clearConnections: connectionsAdapter.removeAll,
	},
	selectors: {
		getConnections: (state, area: string): Connection[] | undefined =>
			selectById(state, area)?.connections,
	},
})

export const {
	reducer: connectionsReducer,
	actions: { setConnections, clearConnections },
	selectors: { getConnections },
} = connectionsSlice.injectInto(reducer)
